import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-input-progress-bar',
  templateUrl: './input-progress-bar.component.html',
  styleUrls: ['./input-progress-bar.component.scss']
})
export class InputProgressBarComponent implements OnInit {

  @Input() class: string;
  @Input() value: number;
  text: string;
  @Input() label: string;

  constructor(
  ) {

  }

  ngOnInit() {
      this.value = null;
  }

  reset() {
      this.value = null;
  }
}
